import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableMobilePickingShowLocationStep = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableMobilePickingShowLocationStep);
};
